/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Pleasewait1Inputs */

const he_verify_pleasewait1 = /** @type {(inputs: Verify_Pleasewait1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אנא המתינו בזמן שאנו מאמתים את הקישור...`)
};

const en_verify_pleasewait1 = /** @type {(inputs: Verify_Pleasewait1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait while we verify your magic link...`)
};

/**
* | output |
* | --- |
* | "Please wait while we verify your magic link..." |
*
* @param {Verify_Pleasewait1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const verify_pleasewait1 = /** @type {((inputs?: Verify_Pleasewait1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Pleasewait1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_verify_pleasewait1(inputs)
	return en_verify_pleasewait1(inputs)
});
export { verify_pleasewait1 as "verify_pleaseWait" }